import * as tokens from '@tokens';

export const IndeterminateIcon = (): JSX.Element => {
  return (
    <svg
      width="10"
      height="2"
      viewBox="0 0 10 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.75C0 0.335786 0.335786 0 0.75 0H9.25C9.66421 0 10 0.335786 10 0.75C10 1.16421 9.66421 1.5 9.25 1.5H0.75C0.335786 1.5 0 1.16421 0 0.75Z"
        fill={tokens.color.text_default_inverse}
      />
    </svg>
  );
};

export const CheckedIcon = (): JSX.Element => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.97412 7.76601L9.78753 1.36379C10.0708 1.05181 10.0708 0.545976 9.78753 0.23399C9.50424 -0.0779966 9.04493 -0.0779967 8.76163 0.23399L3.4612 6.07127L1.23837 3.6233C0.955073 3.31131 0.495763 3.31131 0.21247 3.6233C-0.0708233 3.93528 -0.0708233 4.44111 0.21247 4.7531L2.94822 7.76601C3.23152 8.078 3.69083 8.078 3.97412 7.76601Z"
        fill={tokens.color.text_default_inverse}
      />
    </svg>
  );
};
